import { useId } from 'react';
import classNames from 'classnames';

import {
  CheckboxFilledIcon,
  CheckboxIcon,
  CheckboxPartialIcon,
  CheckMarkAltIcon,
} from '../../icons';

import styles from './_index.module.scss';

export interface CheckboxProps {
  className?: string;
  'data-testid'?: string;
  id?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  isInverseColor?: boolean;
  isPartial?: boolean;
  label?: React.ReactNode;
  onChange?: (value: any) => void;
  title?: string;
  value: any;
}

const Checkbox = ({
  className,
  'data-testid': dataTestId = 'checkbox',
  id,
  isChecked,
  isDisabled,
  isInverseColor,
  isPartial,
  label,
  onChange = () => {},
  title,
  value,
}: CheckboxProps) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;

  const handleChange = () => {
    if (!isDisabled) {
      onChange(value);
    }
  };

  const renderCheckboxIcon = () => {
    if (isInverseColor && isChecked) return <CheckMarkAltIcon />;
    if (isChecked) return <CheckboxFilledIcon />;
    if (isPartial) return <CheckboxPartialIcon />;
    return <CheckboxIcon />;
  };

  return (
    <div
      className={classNames(styles['checkbox'], className, {
        [styles['is-checked']]: isChecked,
        [styles['is-partial']]: isPartial,
      })}
      data-testid={dataTestId}
    >
      <input id={inputId} onChange={handleChange} type="checkbox" />
      <label
        className={classNames(styles['checkbox-label'], {
          [styles['is-disabled']]: isDisabled,
        })}
        htmlFor={inputId}
        title={title}
      >
        <div className={styles['checkbox-icon']}>{renderCheckboxIcon()}</div>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
